import { render, staticRenderFns } from "./GoalSettings.vue?vue&type=template&id=40146e55&"
import script from "./GoalSettings.vue?vue&type=script&lang=js&"
export * from "./GoalSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports